import PropTypes from 'prop-types'

export const REACT_INTL_PROP_TYPE = PropTypes.shape({
  formatMessage: PropTypes.func,
})
export const CREATED_OR_MODIFIED_BY_PROP_TYPE = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.string,
})
